export const services = {
  sites: 'Sites e landing pages', aplicativos: 'Aplicativos', sistemas: 'Sistemas sob medida',
  integracoes: 'Integrações', automacao: 'Automação de processos', ia: 'IA aplicada ao negócio',
  indefinido: 'Ainda não sei',
} as const;
export type Service = keyof typeof services;
export const publicPages = {
  '/': 'Antares Tecnologia GTA — Sites, aplicativos e sistemas',
  '/experience': 'Experiência — Antares Tecnologia GTA',
  '/privacidade': 'Política de Privacidade — Antares Tecnologia GTA',
  '/termos': 'Termos de Uso — Antares Tecnologia GTA',
  '/qrcode': 'Conecte-se à Antares Tecnologia GTA',
} as const;
export type PagePath = keyof typeof publicPages;
export function publicPath(path: string): PagePath | null {
  const normalized = path === '/' ? '/' : path.replace(/\/$/, '');
  return Object.prototype.hasOwnProperty.call(publicPages, normalized) ? normalized as PagePath : null;
}
export const canonicalOrigin = 'https://antarestecnologiagta.com.br';
export const ctaIds = [
  'header_contact', 'hero_contact', 'services_contact', 'footer_contact', 'footer_email',
  'service_sites', 'service_aplicativos', 'service_sistemas', 'service_integracoes', 'service_automacao', 'service_ia',
  'product_zzblu', 'domain_zzblu', 'product_zzblu3d', 'domain_zzblu3d', 'form_fallback', 'qr_instagram',
] as const;
export type CtaId = typeof ctaIds[number];
export type Location = 'header' | 'hero' | 'services' | 'products' | 'contact' | 'footer' | 'qrcode';
export const faqIds = ['projetos', 'contato', 'levantamento', 'prazo_orcamento', 'integracoes'] as const;
// Explicit vocabulary: arbitrary slugs can contain names, emails or client IDs.
export const utmVocabulary = {
  utm_source: ['instagram', 'linkedin', 'google', 'whatsapp', 'newsletter', 'facebook'],
  utm_medium: ['social', 'organic', 'cpc', 'referral', 'messaging', 'email'],
  utm_campaign: ['servicos_antares', 'aplicativos', 'portfolio_antares', 'apresentacao_comercial'],
  utm_content: ['bio', 'story_aplicativos', 'post_pessoal', 'post_empresa', 'apresentacao'],
  utm_term: ['sites', 'aplicativos', 'sistemas', 'integracoes', 'automacao', 'ia'],
} as const;
export type UtmKey = keyof typeof utmVocabulary;
export type Utms = Partial<Record<UtmKey, string>>;
export function sanitizeUtms(search: string): Utms {
  const params = new URLSearchParams(search);
  const result: Utms = {};
  (Object.keys(utmVocabulary) as UtmKey[]).forEach(key => {
    const value = params.get(key);
    if (params.getAll(key).length === 1 && value && value.length <= 64 &&
      /^[a-z][a-z0-9_]*$/.test(value) && (utmVocabulary[key] as readonly string[]).includes(value)) result[key] = value;
  });
  return result;
}
export function reference(raw: string): { domain: string; source: string; medium: string } {
  try {
    const url = new URL(raw);
    if (!['https:', 'http:'].includes(url.protocol)) throw new Error();
    const host = url.hostname.toLowerCase().replace(/^www\./, '');
    if (host === 'antarestecnologiagta.com.br') return { domain: '', source: 'direct_unknown', medium: 'none' };
    const known: Record<string, [string, string]> = {
      'google.com': ['google', 'organic'], 'google.com.br': ['google', 'organic'],
      'instagram.com': ['instagram', 'social'], 'l.instagram.com': ['instagram', 'social'],
      'linkedin.com': ['linkedin', 'social'], 'lnkd.in': ['linkedin', 'social'],
      'facebook.com': ['facebook', 'social'], 'l.facebook.com': ['facebook', 'social'],
      'web.whatsapp.com': ['whatsapp', 'referral'],
    };
    const entry = known[host];
    return entry ? { domain: host, source: entry[0], medium: entry[1] } : { domain: 'other', source: 'other_referral', medium: 'referral' };
  } catch { return { domain: '', source: 'direct_unknown', medium: 'none' }; }
}
